module.exports = __webpack_public_path__ + "media/images/dummy-content/user-2-header-678b0189c8d5338babeea33020e2d6fb.jpg";